import { Home, List, MapPin, MoreHorizontal, Plus } from 'lucide-react';
import { NavLink, useNavigate } from 'react-router-dom';

export function BottomNav({ onAdd }: { onAdd: () => void }) {
  const navigate = useNavigate();
  const item = (to: string, label: string, Icon: typeof Home) => <NavLink to={to} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}><Icon /><span>{label}</span></NavLink>;
  return <nav className="bottom-nav" aria-label="Główna nawigacja">
    {item('/', 'Start', Home)}
    {item('/oferty', 'Oferty', List)}
    <button className="add-nav" onClick={() => { navigate('/dodaj'); onAdd(); }}><span><Plus /></span><em>Dodaj</em></button>
    {item('/mapa', 'Mapa', MapPin)}
    {item('/wiecej', 'Więcej', MoreHorizontal)}
  </nav>;
}
